var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import { mapGetters } from "vuex";
import _ from 'lodash';
import { UrlHelper } from "../../helper/UrlWrapper";
import GlobalVue from "../../globalVue";
import { EPurchaseRefundForUpperSupStatus as EOrderStatus } from "../../enum/EStatus";
import { EBillType } from "../../enum/EBillType";
import { toDetail } from '../../helper/util';
import PurchaseRefundForUpperSupService from '../../api/PurchaseRefundForUpperSupService';
import Add from './Add.vue';
import Header from "./components/Header.vue";
import ArtMsglist from "../../components/alert/ArtMsglist.vue";
import ImportData from "../../components/dataActions/ImportData.vue";
import CommonService from "../../api/CommonService";
var PurchaseRefundForUpperSupList = (function (_super) {
    __extends(PurchaseRefundForUpperSupList, _super);
    function PurchaseRefundForUpperSupList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eOrderStatus = EOrderStatus;
        _this.listData = [];
        _this.total = 0;
        _this.selectRows = [];
        _this.tableHeight = 300;
        _this.dialogVisible = false;
        _this.exportType = "1";
        return _this;
    }
    PurchaseRefundForUpperSupList.prototype.created = function () {
        this.service = PurchaseRefundForUpperSupService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    PurchaseRefundForUpperSupList.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
    };
    PurchaseRefundForUpperSupList.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        if (!filter.s_time) {
            this.$message.error('请选择开始日期');
            return;
        }
        if (!filter.e_time) {
            this.$message.error('请选择结束日期');
            return;
        }
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
        }
        if (_.isDate(filter.e_time)) {
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        filter.order_status = filter.order_status.join(',');
        this.filter = filter;
        this.getList();
    };
    PurchaseRefundForUpperSupList.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getList(Object.assign({}, this.filter, this.filter, pager)).then(function (res) {
            loadingInstance.close();
            var data = res.data.data.map(function (v) {
                v.listGoods = [];
                return v;
            });
            _this.listData = data;
            _this.total = res.data.total;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    PurchaseRefundForUpperSupList.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    PurchaseRefundForUpperSupList.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    PurchaseRefundForUpperSupList.prototype.add = function () {
        this.addTab({
            component: Add,
            title: '添加采购退货',
            showExist: true,
            name: 'purchase_refund_for_upper_supadd',
            cprops: {}
        });
        window._czc.push(["_trackEvent", '采购退货', '采购退货添加']);
    };
    PurchaseRefundForUpperSupList.prototype.edit = function (row) {
        this.addTab({
            component: Add,
            title: '修改采购退货',
            showExist: true,
            name: 'purchase_refund_for_upper_supedit' + row.order_id,
            cprops: {
                orderid: row.order_id
            }
        });
        window._czc.push(["_trackEvent", '采购退货', '采购退货编辑']);
    };
    PurchaseRefundForUpperSupList.prototype.check = function (row) {
        toDetail(EBillType.PurchaseRefundForUpperSup, row.order_id, this);
        window._czc.push(["_trackEvent", '采购退货', '采购退货查看']);
    };
    PurchaseRefundForUpperSupList.prototype.audit = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        this.$confirm("审核后订单不可更改，确定审核吗？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.audit({
                order_ids: _this.selectRows.map(function (item) { return item.order_id; }).join(",")
            }).then(function (res) {
                loadingInstance.close();
                if (res.data.success) {
                    if (res.data.code == 3) {
                        var html = "<div>" + res.data.msg + "</div>";
                        _this.$confirm(html, '提示', {
                            dangerouslyUseHTMLString: true,
                            customClass: 'confirm',
                            confirmButtonText: '知道了',
                            showCancelButton: false
                        }).catch(function (err) {
                            console.log(err);
                        });
                        return;
                    }
                    if (res.data.code == 49) {
                        var instance = _this.$dialog(ArtMsglist, {
                            data: {
                                msgData: res.data.data,
                            }
                        }, {
                            title: "提示",
                            width: 450,
                            height: 350
                        }).instance;
                    }
                    else if (res.data.code == 76) {
                        _this.$message.error(res.data.msg);
                        _this.getList();
                    }
                    else {
                        _this.$message.success('审核成功!');
                        _this.getList();
                    }
                }
                else {
                    loadingInstance.close();
                    _this.$message.error(res.data.msg);
                }
                window._czc.push(["_trackEvent", '采购退货', '采购退货审核']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseRefundForUpperSupList.prototype.discard = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        this.$confirm("确认后会废弃退货单，且不可再次提交，确定废弃吗？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.discard({
                order_ids: _this.selectRows.map(function (item) { return item.order_id; }).join(",")
            }).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success("废弃成功");
                    window._czc.push(["_trackEvent", '采购退货', '采购退货废弃']);
                }
                _this.getList();
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseRefundForUpperSupList.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    PurchaseRefundForUpperSupList.prototype.operateCommand = function (command) {
        switch (command) {
            case 1:
                this.importAudit();
                break;
            case 2:
                this.mulExport();
                break;
            case 3:
                this.discard();
                break;
            case 4:
                this.print();
                break;
            case 5:
                this.handleSendEmail();
                break;
            case 6:
                this.PDFfile();
                break;
        }
    };
    PurchaseRefundForUpperSupList.prototype.importAudit = function () {
        this.$refs.ImportData.showImportModal();
    };
    PurchaseRefundForUpperSupList.prototype.mulExport = function () {
        this.dialogVisible = true;
    };
    PurchaseRefundForUpperSupList.prototype.confirmExport = function () {
        var _this = this;
        var orderIds = [];
        this.selectRows.forEach(function (item) {
            orderIds.push(item.order_id);
        });
        var url = "supplierclientapi/upperrefund/" + (this.exportType == '1' ? 'export_orders' : 'export_order_details') + "?order_ids=" + orderIds.join(",");
        url = UrlHelper.addParam(url, 'token', this.user.token);
        var filter = _.cloneDeep(this.$refs.listHeader.formData);
        if (!filter.s_time) {
            this.$message.error('请选择开始日期');
            return;
        }
        if (!filter.e_time) {
            this.$message.error('请选择结束日期');
            return;
        }
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
        }
        if (_.isDate(filter.e_time)) {
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        filter.order_status = filter.order_status.join(',');
        this.filter = filter;
        for (var key in this.filter) {
            this.filter[key] = (this.filter[key] === undefined || this.filter[key] === null) ? '' : this.filter[key];
            url = UrlHelper.addParam(url, key, this.filter[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        if (this.exportType == '1') {
            window._czc.push(["_trackEvent", '采购退库', '采购退库导出', '导出单据']);
        }
        if (this.exportType == '2') {
            window._czc.push(["_trackEvent", '采购退库', '采购退库导出', '导出明细']);
        }
    };
    PurchaseRefundForUpperSupList.prototype.print = function () {
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        var orderIds = [];
        this.selectRows.forEach(function (item) {
            orderIds.push(item.order_id);
        });
        var url = "./static/js/print/print2.html";
        url = UrlHelper.addParam(url, 'type', "purchaseRefundForUpperSup");
        url = UrlHelper.addParam(url, 'order_id', orderIds.join(","));
        url = UrlHelper.addParam(url, 'token', this.user.token);
        UrlHelper.windowOpenIntercept(url);
        window._czc.push(["_trackEvent", '采购退货', '采购退货打印']);
    };
    PurchaseRefundForUpperSupList.prototype.PDFfile = function () {
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        var orderIds = [];
        this.selectRows.forEach(function (item) {
            orderIds.push(item.order_id);
        });
        var url = "./static/js/print/print2.html";
        url = UrlHelper.addParam(url, 'type', "purchaseRefundForUpperSup");
        url = UrlHelper.addParam(url, 'order_id', orderIds.join(","));
        url = UrlHelper.addParam(url, 'is_download', 1);
        url = UrlHelper.addParam(url, 'token', this.user.token);
        UrlHelper.windowOpenIntercept(url);
        window._czc.push(["_trackEvent", '采购退货', '采购退货pdf下载']);
    };
    PurchaseRefundForUpperSupList.prototype.handleSendEmail = function (row) {
        if (!row) {
            if (!this.selectRows || !this.selectRows.length) {
                this.$message.warning("请选择单据");
                return;
            }
            console.log(this.selectRows);
            var order_ids_1 = [];
            this.selectRows.map(function (item) {
                if (item.is_send_email == 0) {
                    order_ids_1.push(item.order_id);
                }
            });
            if (!order_ids_1 || !order_ids_1.length) {
                this.$message.warning("只有选中单据全部未发送过邮件才可进行此操作");
                return;
            }
            this.sendEmail(order_ids_1.join());
        }
        else {
            this.sendEmail(row.order_id);
        }
    };
    PurchaseRefundForUpperSupList.prototype.sendEmail = function (order_ids) {
        var _this = this;
        this.$confirm("确认后会向供应商发送退货邮件，确认发送吗?").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.sendEmail({
                order_ids: order_ids
            }).then(function (res) {
                loadingInstance.close();
                _this.$message.success("发送成功");
                window._czc.push(["_trackEvent", '采购订货', '发送邮件']);
                _this.getList();
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseRefundForUpperSupList.prototype.expandChange = function (row, expandedRows) {
        var _this = this;
        if (expandedRows.length == 0) {
            return;
        }
        var params = {
            order_id: row.order_id
        };
        var index = this.listData.indexOf(row);
        this.service.getListGoods(params).then(function (res) {
            var listGoods = res.data.data;
            listGoods.push({ isBtn: true });
            GlobalVue.$set(_this.listData[index], 'listGoods', listGoods);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PurchaseRefundForUpperSupList = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user",
                "canSendEmail": "canSendEmail"
            })),
            components: {
                'list-header': Header,
                'import-data': ImportData,
            }
        })
    ], PurchaseRefundForUpperSupList);
    return PurchaseRefundForUpperSupList;
}(Vue));
export default PurchaseRefundForUpperSupList;
